<h1 mat-dialog-title>

    <i class="fa fa-plus primaryColorBorder icon_header"> </i>

    <span class="bold primaryColor " style="font-size: 17px;">{{ 'edit_style.title' | translate }}
    </span>

    <i (click)="close()" class="fa fa-times primaryColor pointer close"></i>
</h1>


<mat-dialog-content>
    <form [formGroup]="formEditStyle" >
        <mat-form-field appearance="outline" *ngIf="formEditStyle.get('name')" style="width: 100%;">
            <mat-label> {{ 'add_style.name' | translate }} </mat-label>
            <input matInput formControlName="name">
            <mat-error> {{ 'add_icon.category_error' | translate }} </mat-error>
        </mat-form-field>

        <app-file-upload *ngIf="formEditStyle.get('qml_file')" formControlName="qml_file"  [multiple]="false" [accept]="'.qml'" ></app-file-upload>
        <!-- <span *ngIf="hasError('qml_file', 'required')" > {{ 'add_style.qml_error' | translate }} </span> -->
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <div fxLayout fxLayoutGap="15px" fxLayoutAlign="end" >
        <mat-progress-bar fxFlex="100%" mode="indeterminate" *ngIf="formEditStyle.disabled" ></mat-progress-bar>
        <button fxFlex="150px" mat-stroked-button color="primary" [disabled]="formEditStyle.disabled" (click)="close()">{{ 'cancel' | translate }}</button>
        <button fxFlex="150px" mat-flat-button color="accent" class="white" (click)="onEditInstance()" [disabled]="!formEditStyle.valid || formEditStyle.disabled" >   {{ 'save' | translate }} </button>
    </div>
</mat-dialog-actions>